export const SET_COACH_TASKS = "SET_COACH_TASKS";
export const UPDATE_COACH_TASK = "UPDATE_COACH_TASK";
export const SET_COACH_TASK_TICKETS = "SET_COACH_TASK_TICKETS";
export const UPDATE_COACH_TASK_TICKET = "UPDATE_COACH_TASK_TICKET";
export const REMOVE_COACH_TASK_TICKET = "REMOVE_COACH_TASK_TICKET";
